import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MainButton } from 'elements/button/MainButton';
import { EFonts } from 'libs/styles/styling';
import { EWorldColor } from 'static/config/worldVariables';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    worldMapId: string;
}

export const DetailBookingFailed = (props: Props) => {
    return (
        <S_DetailBookingFailed className={props.className}>
            <S_IconContainer>
                <S_Icon icon={['fas', 'circle-xmark']} />
                <S_Title>{Localization.BOOKING_FAILED_TITLE}</S_Title>
            </S_IconContainer>
            <S_Text>{Localization.BOOKING_FAILED_MESSAGE}</S_Text>
            <S_SubmitButton
                type={'primary'}
                alignText="center"
                onClick={() => {
                    window.location.href = '/map/' + props.worldMapId;
                }}
            >
                {Localization.REFRESH_PAGE}
            </S_SubmitButton>
        </S_DetailBookingFailed>
    );
};

const S_DetailBookingFailed = styled.div``;

const S_Text = styled.div`
    margin-bottom: 25px;
    font-family: ${EFonts.Regular};
    line-height: 1.4em;
`;

const S_SubmitButton = styled(MainButton)`
    height: 40px;
    width: 200px;
    margin: 10px auto;
`;

const S_IconContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 60px;
    color: #${EWorldColor.RED};
    margin-bottom: 20px;
`;

const S_Title = styled.div`
    font-family: ${EFonts.Bold};
    text-align: center;
    margin-bottom: 20px;
`;
